import { render, staticRenderFns } from "./zuzhi.vue?vue&type=template&id=4b8b00b8&scoped=true&"
import script from "./zuzhi.vue?vue&type=script&lang=js&"
export * from "./zuzhi.vue?vue&type=script&lang=js&"
import style0 from "./zuzhi.vue?vue&type=style&index=0&id=4b8b00b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b00b8",
  null
  
)

export default component.exports